import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Tooltip';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { Maybe } from 'types/UtilityTypes';

type MessageExistingLoadsProps = {
  threadLoadCount: number;
  threadFreightTrackingIDs: Maybe<string[]>;
  onOpenLoadsView: () => void;
};

// Right-aligned "+ N existing loads mentioned"; tooltip lists thread load IDs.
export function MessageExistingLoads({
  threadLoadCount,
  threadFreightTrackingIDs,
  onOpenLoadsView,
}: MessageExistingLoadsProps) {
  return (
    <Flex direction='row' justify='end' className='w-full'>
      <Tooltip delayDuration={10}>
        <TooltipTrigger asChild>
          <button
            type='button'
            onClick={onOpenLoadsView}
            className='text-right transition-colors cursor-pointer py-0.5 pl-2'
          >
            <Typography
              variant='body-xs'
              weight='medium'
              className='text-[11px] text-accent-600'
            >
              {`+ ${threadLoadCount} ${
                threadLoadCount === 1
                  ? 'existing load mentioned'
                  : 'existing loads mentioned'
              }`}
            </Typography>
          </button>
        </TooltipTrigger>
        <TooltipContent
          side='top'
          className='max-w-sm max-h-[400px] overflow-y-auto border border-neutral-200 bg-neutral-50 p-2 shadow-lg'
          sideOffset={6}
        >
          <Typography
            variant='body-xxs'
            weight='semibold'
            className='text-neutral-700 mb-2'
          >
            Loads in this thread
          </Typography>
          <Flex direction='col' gap='xs' className='gap-y-0.5'>
            {(threadFreightTrackingIDs ?? []).map((freightId) => (
              <Typography
                key={freightId}
                variant='body-xxs'
                weight='semibold'
                className='text-neutral-700 font-mono'
              >
                {freightId}
              </Typography>
            ))}
          </Flex>
        </TooltipContent>
      </Tooltip>
    </Flex>
  );
}
